
import React, { useState, useEffect } from 'react';
import useEffectOnce from '../hooks/useEffectOnce';
import { useDispatch, useSelector } from 'react-redux';
import './SuprivisorDashboard.css';
import { fetchData } from '../reduxactions/adminactions/DashboardActions';
import { RootState } from '../reducers';
import { Panel } from 'primereact/panel';
import { Chart } from 'primereact/chart';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { SUPRIVISOR_API } from '../ApiNames';
import { LoginService } from '../services/LoginService';
import { fetchDonorChartData, fetchPieChartData } from '../reduxactions/suprivisoractions/SuprivisorDashActions';

export const SuprivisorDashboard = () => {
  const uid = window.sessionStorage.getItem('uid');
  const [globalFilter, setGlobalFilter] = useState('');
  


  const [doctorCount, setDoctorCount] = useState<number | null>(null);


  const [userData, setUserData] = useState<[]>([]);

  const getdash = async () => {
    try {
      const payload = { q: 1,userid:uid };
      const apiname = SUPRIVISOR_API.sdashboard;
      const data = await LoginService.getData(apiname, payload);
      setUserData(data);
      //const doctor_count = data[0]?.doctor_count;
      // const usertype = data[0]?.usertype

    } catch (error) {

    }
  };
  const [user, setUser] = useState<[]>([]);


  const getdash1 = async () => {
    try {
      const payload1 = { q: 2,userid:uid };
      const apiname = SUPRIVISOR_API.sdashboard;
      const data1 = await LoginService.getData(apiname, payload1);
      setUser(data1);
      // const doctor_count = data[0]?.doctor_count;
      // const usertype = data[0]?.usertype

    } catch (error) {

    }
  };
  const [user1, setUser1] = useState<[]>([]);

  const getdash2 = async () => {
    try {
      const payload = { q: 3,userid:uid };
      const apiname = SUPRIVISOR_API.sdashboard;
      const data2 = await LoginService.getData(apiname, payload);
      setUser1(data2);
      // const doctor_count = data[0]?.doctor_count;
      // const usertype = data[0]?.usertype

    } catch (error) {

    }
  };
  const [user2, setUser2] = useState<[]>([]);

  const getdash3 = async () => {
    try {
      const payload = { q: 4,userid:uid };
      const apiname = SUPRIVISOR_API.sdashboard;
      const data3 = await LoginService.getData(apiname, payload);
      setUser2(data3);
      // const doctor_count = data[0]?.doctor_count;
      // const usertype = data[0]?.usertype

    } catch (error) {

    }
  };





  useEffectOnce(() => {
    getdash();
    getdash2();
    getdash3();
    getdash1();

  }, []);
  const dispatch = useDispatch();
  useEffectOnce(() => {
    const fetchDataAsync = async () => {
      try {
        await dispatch(fetchPieChartData(uid) as any);
        await dispatch(fetchDonorChartData(uid) as any);



      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchDataAsync();
  }, [dispatch]);
  const piechartData = useSelector((state: RootState) => state.sdash.pieChartData);
  const ManagerchartData = useSelector((state: RootState) => state.sdash.donorChartData);
  const piechartOptions = useSelector((state: RootState) => state.sdash.piechartOptions);
  const ManagerchartOptions = useSelector((state: RootState) => state.sdash.donorChart);
//for help
 const [openHelp, setHelp] = useState(false);
 const url1 = window.sessionStorage.getItem("apiRoot");
 const IUrl = `${url1}/help/sup-dashboard.php`;
 const helpImg = `${url1}/help/help3.png`;
 const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
   event.preventDefault();
   const newWindowReference = window.open(
     targetUrl,
     'newwindow',
     'width=1000,height=1000,noopener,noreferrer'
   );
 
   if (newWindowReference) {
       newWindowReference.opener = null;
   }
 };

  return (
<div className="grid">
      <div className="main-content">
        <div className="content-wrapper">
          <section className="content-header">
            <div className="container-fluid">
              <div className="grid mb-2">
                <div className="col-9">
                  <h1>Dashboard</h1>
                </div>
                 <div className="col-3">
                <a
                  title="help"
                 onClick={(e) => openWindow(e, IUrl)}
                  style={{
                   
                    color: "blue",
                    fontSize: 15, cursor: "pointer"
                  }}
                >Help for this Page &nbsp;
                <i style={{marginTop: 40,backgroundColor: "orange",color:"white" }} className = "pi pi-question-circle"></i>
                 
                </a>
              </div>
              </div>
            </div>
          </section>
          <section className="content">
            <div className="grid">
              <div className="col-3">
                <div>
                <div className="surface-0 shadow-2 p-3 border-1 border-50 border-round  bg-orange-200">
                <div className="flex justify-content-between mb-3">
                      <div>
                        <span className="block text-500 font-medium mb-3 text-900">Doctors</span>
                        <div className="text-900 font-medium text-xl">
                          {userData}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-3">
                <div className="surface-0 shadow-2 p-3 border-1 border-50 border-round bg-green-200 ">
                  <div className="flex justify-content-between mb-3">
                    <div>
                      <span className="block text-500 font-medium mb-3 text-900">Assistants</span>
                      <div className="text-900 font-medium text-xl">{user}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-3">
                <div className="surface-0 shadow-2 p-3 border-1 border-50 border-round bg-bluegray-400">
                  <div className="flex justify-content-between mb-3">
                    <div>
                      <span className="block text-500 font-medium mb-3 text-900">Link Assistants</span>
                      <div className="text-900 font-medium text-xl">{user1}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-3">
                <div className="surface-0 shadow-2 p-3 border-1 border-50 border-round bg-bluegray-400">
                  <div className="flex justify-content-between mb-3">
                    <div>
                      <span className="block text-500 font-medium mb-3 text-900">Cases</span>
                      <div className="text-900 font-medium text-xl">{user2}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="grid">
                <section className="col-6">
                  <div className="box box-danger">
                    <Panel header="Payment Details" toggleable>
                    <Chart type="pie" style={{ height: '450px' }} data={piechartData} options={piechartOptions} />
                    </Panel>
                  </div>
                </section>
                <section className="col-6">
                  <div className="box box-danger">
                    <Panel header="Cases" toggleable>
                      <Chart type="pie" style={{ height: '450px' }} data={ManagerchartData} options={ManagerchartOptions} />

                    </Panel>
                  </div>
                </section>
              </div> 



          </section>
        </div>
      </div>
    </div>
      )
}
